/*
 * Copyright (c) Dito Technologies
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    UpdatePieceFileDeleteNoteMutation$variables
} from "mutation/__generated__/UpdatePieceFileDeleteNoteMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation UpdatePieceFileDeleteNoteMutation($input: MusicUpdatePieceFileDeleteNoteInput!) {
        music_update_piece_file_delete_note(input: $input) {
            piece {
                id
                ...PiecePlayBody_piece
            }
        }
    }
`;

export default function UpdatePieceFileDeleteNote(pieceId: string, bulbId: string) {
    const variables: UpdatePieceFileDeleteNoteMutation$variables = {
        input: {
            piece_id: pieceId,
            bulb_id: bulbId
        }
    };
    return perform(mutation, variables);
}
